import { createApp } from 'vue';
import App from './App.vue';
import PhoneView from './components/PhoneView.vue';
import { flushQueuedBugReports } from './utils/bugReports';
import { initUpdateCheck } from './utils/checkForUpdate';
import { trackUsage } from './utils/usage.js';
import './utils/screenPin.js'; // keeps the bug button at the real bottom of the screen (iOS cuts the page short)

// One anonymous ping per open → Bug Desk's Visitors tab (house module).
trackUsage('couch-blocks');

// A phone that scanned the TV's party code gets the phone screen instead of
// the couch game: https://couchblocks.aroundtableround.com/?party=ABCD
const partyCode = new URLSearchParams(window.location.search).get('party');
const app = partyCode
  ? createApp(PhoneView, { code: partyCode.toUpperCase() }).mount('#app')
  : createApp(App).mount('#app');

// Replay any bug report that was written while offline. Silent - see
// utils/bugReports.js.
flushQueuedBugReports();

// New deploys reload the page by themselves - but only in the lobby or on
// the game-over screen, never with a well in play (see utils/appUpdate.js).
initUpdateCheck(() => (partyCode ? app.step === 'play' || app.step === 'lobby'
  : app.screen === 'playing' || app.screen === 'paused'));

// Production-only service worker (vite.config.js). The whole game runs in
// the browser, so once it has loaded once it plays with no connection.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`).catch(() => {
      // A failed registration must never stop the game from running.
    });
  });
}
